import React from 'react';
import PropTypes from 'prop-types';
import AppModal from '../Modals/AppModal';
import { Table, Column, Cell } from 'fixed-data-table-2';
import UIDateFormater, {
  DateType,
} from '../../containers/UIhelper/UIDateFormater';
import ReactPaginate from 'react-paginate';
import { getProjectConfigurationsLogs } from '../../actions/DeviceConfigurationAction';
import { useDispatch } from 'react-redux';
import useProjectTimezone from '../../hooks/useProjectTimeZone';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const ROWS_FOR_PAGE = 250;
const SOURCE_ALL = 'ALL';

const ConfigurationLogsModal = (props, context) => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const [sourceFilter, setSourceFilter] = React.useState('AQS');
  const [uiInfo, setUiInfo] = React.useState({
    height: 0,
    width: 0,
  });
  const projectTimezone = useProjectTimezone();
  const dispatch = useDispatch();

  React.useEffect(() => {
    const screen = window.screen;
    const uiInfo = {
      height: screen.height,
      width: screen.width,
    };
    setUiInfo(uiInfo);
  }, []);

  React.useEffect(() => {
    if (props.open) {
      dispatch(
        getProjectConfigurationsLogs(
          currentPage - 1,
          sourceFilter === SOURCE_ALL ? '' : sourceFilter
        )
      );
    }
  }, [props.open, currentPage, sourceFilter, dispatch]);

  React.useEffect(() => {
    if (!props.open) {
      setCurrentPage(1);
      setSourceFilter('AQS');
    }
  }, [props.open]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  const handleSourceChange = (event) => {
    setCurrentPage(1);
    setSourceFilter(event.target.value);
  };

  return (
    <AppModal
      closeIcon
      fullWidth
      maxWidth={false}
      open={props.open}
      onClose={() => {
        setCurrentPage(1);
        props.closeLogsModal();
      }}
      title={context.t('device_configuration_messages_logs')}
      content={
        <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 1.5,
              mb: 2,
            }}
          >
            <FormControl size='small' variant='outlined' sx={{ minWidth: 180 }}>
              <InputLabel id='g5-message-log-source-label'>
                {context.t('source')}
              </InputLabel>
              <Select
                labelId='g5-message-log-source-label'
                id='g5-message-log-source'
                value={sourceFilter}
                label={context.t('source')}
                onChange={handleSourceChange}
              >
                <MenuItem value={SOURCE_ALL}>{context.t('all')}</MenuItem>
                <MenuItem value='AQS'>AQS</MenuItem>
                <MenuItem value='Device'>Device</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Table
            keyboardScrollEnabled
            keyboardPageEnabled
            maxHeight={uiInfo.height * 0.48}
            width={uiInfo.width * 0.9}
            rowsCount={props.data.length}
            rowHeight={100}
            headerHeight={30}
          >
            <Column
              columnKey='#'
              width={5}
              align='center'
              header={<Cell>#</Cell>}
              flexGrow={0.3}
              cell={(col) => (
                <Cell>
                  {col.rowIndex + 1 + (currentPage - 1) * ROWS_FOR_PAGE}
                </Cell>
              )}
            />

            <Column
              columnKey='Timestamp'
              width={30}
              header={<Cell>{context.t('time')}</Cell>}
              flexGrow={1}
              cell={(col) => {
                const val = props.data[col.rowIndex]['Timestamp'];
                const time = UIDateFormater(
                  val,
                  DateType.DATE_AND_TIME,
                  props.timeZone,
                  projectTimezone
                );
                return <Cell>{time}</Cell>;
              }}
            />

            <Column
              columnKey='DeviceID'
              width={30}
              header={<Cell>{context.t('device_id')}</Cell>}
              flexGrow={1}
              cell={(col) => (
                <Cell>{props.data[col.rowIndex]['DeviceID']}</Cell>
              )}
            />

            <Column
              columnKey='MessageSource'
              width={30}
              header={<Cell>{context.t('source')}</Cell>}
              flexGrow={1}
              cell={(col) => (
                <Cell>{props.data[col.rowIndex]['MessageSource']}</Cell>
              )}
            />

            <Column
              columnKey='MessageCodeText'
              width={30}
              header={<Cell>{context.t('code')}</Cell>}
              flexGrow={1}
              cell={(col) => (
                <Cell>{props.data[col.rowIndex]['MessageCodeText']}</Cell>
              )}
            />

            <Column
              columnKey='MessagePayload'
              width={30}
              header={<Cell>{context.t('payload')}</Cell>}
              flexGrow={4}
              align='left'
              cell={(col) => (
                <Cell title={props.data[col.rowIndex]['MessagePayload']}>
                  {props.data[col.rowIndex]['MessagePayload']}
                </Cell>
              )}
            />

            <Column
              columnKey='UserName'
              width={30}
              header={<Cell>{context.t('user')}</Cell>}
              flexGrow={1}
              align='left'
              cell={(col) => (
                <Cell title={props.data[col.rowIndex]['UserName']}>
                  {props.data[col.rowIndex]['UserName']}
                </Cell>
              )}
            />

            {/* <Column columnKey='Timestamp' headerLabel={context.t('Time')} renderFunc={(value) => UIDateFormater(value, DateType.DATE_AND_TIME, props.timeZone)} />
            <Column columnKey='DeviceID' headerLabel={context.t('Device ID')} />
            <Column columnKey='MessageSource' headerLabel={context.t('Source')} />
            <Column columnKey='MessageCodeText' headerLabel={context.t('Code')} />
            <Column columnKey='MessagePayload' headerLabel={context.t('Payload')} /> */}
          </Table>
          {/*<Pagination*/}
          {/*  prevPageText={context.t('prev')}*/}
          {/*  nextPageText={context.t('next')}*/}
          {/*  firstPageText={context.t('first')}*/}
          {/*  lastPageText={context.t('last')}*/}
          {/*  activePage={currentPage}*/}
          {/*  itemsCountPerPage={250}*/}
          {/*  totalItemsCount={props?.data[0]?.Total || 0}*/}
          {/*  pageRangeDisplayed={5}*/}
          {/*  onChange={handlePageClick}*/}
          {/*/>*/}
          <ReactPaginate
            previousLabel={context.t('prev')}
            nextLabel={context.t('next')}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={Math.ceil((props?.data[0]?.Total || 0) / ROWS_FOR_PAGE)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            onPageActive={currentPage}
          />
        </>
      }
    />
  );
};

ConfigurationLogsModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default ConfigurationLogsModal;
